const schemas = [
  {
    id: 1,
    title: "Devoluciones",
    name: "devoluciones",
    data: [],
    totalValor: 0,
    search: "",
    page: 1,
    headers: [
      "Cso",
      "Paciente",
      "Cedula",
      "Fecha",
      "Valor",
      "Odontólogo",
      "RutProfesional",
      "Mes",
      "Anio",
    ],
  },
  {
    id: 2,
    title: "Implantes montados",
    name: "implantesMontados",
    data: [],
    totalValor: 0,
    search: "",
    page: 1,
    headers: [
      "Cso",
      "Paciente",
      "Cedula",
      "Cantidad",
      "Fecha venta",
      "Fecha evolución",
      "Odontólogo",
      "RutProfesional",
      "Mes",
      "Anio",
    ],
  },
  {
    id: 3,
    title: "Subvención y costos asociados",
    name: "subvenciones",
    data: [],
    totalValor: 0,
    search: "",
    page: 1,
    headers: [
      "Entidad",
      "Titular",
      "Nombre titular",
      "Valor crédito",
      "Tasa",
      "Valor descuento",
      "Paciente",
      "Nombre paciente",
      "Cso",
      "Odontólogo",
      "RutProfesional",
      "Mes",
      "Anio",
    ],
  },
  {
    id: 4,
    title: "Liquidación PACKS fase higiénica (incentivos)",
    name: "packsHigienicos",
    data: [],
    totalValor: 0,
    search: "",
    page: 1,
    headers: [
      "Clinica",
      "Odontólogo",
      "Cedula",
      "Cargo",
      "Numero odontólogos por clinica",
      "Meta clinica",
      "Meta odontólogo",
      "Packs montados",
      "Porcentaje cumplimiento",
      "Incentivo",
      "FechaPresupuesto",
      "Mes",
      "Anio",
    ],
  },
];

export default schemas;
